import './index.css';

export type {
  SimpleListProps,
  SimpleListItem,
  SimpleListSize,
} from './SimpleList';
export {default as default, SIMPLE_LIST_DEFAULT_ICON} from './SimpleList';
